module.exports = __webpack_public_path__ + "media/images/tigor/tigor4-80aba64fe10a0ea3410f37be775d9ddf.png";